"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    shareAssessmentModal: {
        shareAssessmentHeading: 'Share',
        shareAssessmentButton: 'SHARE',
        fetchingInformation: 'Fetching teachers...',
        shareSuccess: 'Shared with {{teacherCount}} {{teachers}}, this may take some time.',
        schoolPlaceHolder: 'School',
        allTeachers: 'All Teachers',
        labelTeacher: '{{name}} checkbox',
        labelAllTeachers: 'select all {{totalTeachers}} teachers checkbox',
        noTeachersFound: 'There are no eligible teachers available for selected criteria',
    },
};
